import config from "../config";
import router from '../Routes';
import * as Realm from 'realm-web';

const app = Realm.getApp(config.REALM_APP_ID);

export default {
  namespaced: true,
  state: {
    isFetching: false,
    errorMessage: ''
  },
  mutations: {
    REGISTER_REQUEST(state) {
      state.isFetching = true;
    },
    REGISTER_SUCCESS(state) {
      state.isFetching = false;
      state.errorMessage = '';
    },
    REGISTER_FAILURE(state, payload) {
      state.isFetching = false;
      state.errorMessage = payload;
    },
  },
  actions: {
    registerUser({dispatch}, payload) {
      if (!config.isBackend) {
        router.push('/user/profile');
      }

      else {
        dispatch('requestRegister');
        const creds = payload.creds;
        if (creds.email.length > 0 && creds.password.length > 0) {
          dispatch('registerWithEmail', creds)
        } else {
          dispatch('registerError', 'Something was wrong. Try again');
        }
      }
    },
    async registerWithEmail({dispatch}, creds) {
      await app.emailPasswordAuth.registerUser(creds.email, creds.password);
      await dispatch('auth/loginUser', creds, { root: true });
      dispatch('receiveRegister', creds);
    },
    requestRegister({commit}) {
      commit('REGISTER_REQUEST');
    },
    receiveRegister({commit}) {
      commit('REGISTER_SUCCESS');
    },
    registerError({commit}, payload) {
      commit('REGISTER_FAILURE', payload);
    },
  },
};
